﻿import AInntektValg from './Utilities/A-InntektValg';
import { ValgState } from './Store/Valg/Types';
import { Resultat } from './Models/Resultat/Resultat';
import { Modal } from './Models/Resultat/Modal';
import { Ekstraboks } from './Models/Resultat/Ekstraboks';
import VeilederIofDto from './Models/VeilederIofDto';
import { Satser } from './Utilities/SatserApi';

enum ResultatType {
    Uknown,
    ResA,
    ResB,
    ResC,
    ResD,
    ResE,
}

const visEkstraboks = (state: ValgState): boolean => {
    if (state.aInntekt !== undefined) {
        return state.aInntekt.value === AInntektValg.a1_egenInntekt || state.aInntekt.value === AInntektValg.a5_trygd;
    }
    return false;
};

const erModalLenkeOgDobbelSum = (state: ValgState): boolean => {
    if (state.aInntekt !== undefined) {
        return (
            state.aInntekt.value === AInntektValg.a1_egenInntekt ||
            state.aInntekt.value === AInntektValg.a4_formue ||
            state.aInntekt.value === AInntektValg.a5_trygd
        );
    }
    return false;
};

export const getSumOver = (state: ValgState, satser: Satser): number => {
    const valg = findResultat(state);
    if (valg === ResultatType.ResA) {
        return satser.ST04_InntektsgrenseDager211X;
    } else if (valg === ResultatType.ResB) {
        return satser.ST04_InntektsgrenseEktefelle;
    } else if (valg === ResultatType.ResC) {
        return satser.GrenseForeldreInntekt;
    } else if (valg === ResultatType.ResD) {
        return satser.ST04_FormuegrenseEnslig;
    } else if (valg === ResultatType.ResE) {
        return satser.ST04_TrygdegrenseDager211X;
    }
    return -99;
};

export const getSumUnder = (state: ValgState, satser: Satser): number => {
    const valg = findResultat(state);
    if (valg === ResultatType.ResA) {
        return satser.ST04_InntektsgrenseDager0210;
    } else if (valg === ResultatType.ResD) {
        return satser.ST04_FormuegrenseGift;
    } else if (valg === ResultatType.ResE) {
        return satser.ST04_TrygdegrenseDager0210;
    }
    return -99;
};

export const getResultat = (state: ValgState): Resultat => {
    const valg = findResultat(state);
    if (valg === ResultatType.ResA) {
        return {
            visEkstraboks: visEkstraboks(state),
            erModalLenkeOgDobbelSum: erModalLenkeOgDobbelSum(state),
            tittel: 'resultatEgenInntektTittel' as keyof VeilederIofDto,
            ingress: 'resultatEgenInntektIngress' as keyof VeilederIofDto,
            kronerDekorasjon: 'kronerDekorasjon' as keyof VeilederIofDto,
            dekorasjonOver: 'resultatEgenInntektDekorasjonOverSjuManeder' as keyof VeilederIofDto,
            dekorasjonUnder: 'resultatEgenInntektDekorasjonUnderSjuManeder' as keyof VeilederIofDto,
            modalLenketekst: 'resultatEgenInntektLenketekstModal' as keyof VeilederIofDto,
        };
    } else if (valg === ResultatType.ResB) {
        return {
            visEkstraboks: visEkstraboks(state),
            erModalLenkeOgDobbelSum: erModalLenkeOgDobbelSum(state),
            tittel: 'resultatEktefelleSamboerTittel' as keyof VeilederIofDto,
            ingress: 'resultatEktefelleSamboerIngress' as keyof VeilederIofDto,
            kronerDekorasjon: 'kronerDekorasjon' as keyof VeilederIofDto,
            dekorasjonOver: 'resultatEktefelleSamboerDekorasjon' as keyof VeilederIofDto,
            lenke: 'resultatEktefelleSamboerLenke' as keyof VeilederIofDto,
        };
    } else if (valg === ResultatType.ResC) {
        return {
            visEkstraboks: visEkstraboks(state),
            erModalLenkeOgDobbelSum: erModalLenkeOgDobbelSum(state),
            tittel: 'resultatForeldreTittel' as keyof VeilederIofDto,
            ingress: 'resultatForeldreIngress' as keyof VeilederIofDto,
            kronerDekorasjon: 'kronerDekorasjon' as keyof VeilederIofDto,
            dekorasjonOver: 'resultatForeldreDekorasjon' as keyof VeilederIofDto,
            lenke: 'resultatForeldreLenke' as keyof VeilederIofDto,
        };
    } else if (valg === ResultatType.ResD) {
        return {
            visEkstraboks: visEkstraboks(state),
            erModalLenkeOgDobbelSum: erModalLenkeOgDobbelSum(state),
            tittel: 'resultatFormueTittel' as keyof VeilederIofDto,
            ingress: 'resultatFormueIngress' as keyof VeilederIofDto,
            kronerDekorasjon: 'kronerDekorasjon' as keyof VeilederIofDto,
            dekorasjonOver: 'resultatFormueDekorasjonUtenFellesBarn' as keyof VeilederIofDto,
            dekorasjonUnder: 'resultatFormueDekorasjonMedFellesBarn' as keyof VeilederIofDto,
            modalLenketekst: 'resultatFormueLenketekstModal' as keyof VeilederIofDto,
        };
    } else {
        return {
            visEkstraboks: visEkstraboks(state),
            erModalLenkeOgDobbelSum: erModalLenkeOgDobbelSum(state),
            tittel: 'resultatTrygdTittel' as keyof VeilederIofDto,
            ingress: 'resultatTrygdIngress' as keyof VeilederIofDto,
            kronerDekorasjon: 'kronerDekorasjon' as keyof VeilederIofDto,
            dekorasjonOver: 'resultatTrygdDekorasjonOverSjuManeder' as keyof VeilederIofDto,
            dekorasjonUnder: 'resultatTrygdDekorasjonUnderSjuManeder' as keyof VeilederIofDto,
            modalLenketekst: 'resultatTrygdLenketekstModal' as keyof VeilederIofDto,
        };
    }
};

export const getInntektsgrenseBostipendLaerlingelonn = (satser: Satser): number => {
    return satser.ST01_BostipendLaerlingelonnNedreGrenseTrekk;
};

export const getEkstraboks = (state: ValgState): Ekstraboks | undefined => {
    const valg = findResultat(state);

    if (valg === ResultatType.ResA) {
        return {
            tittelLaerlinger: 'ekstraboksEgenInntektTittelLaerlinger' as keyof VeilederIofDto,
            ingressLaerlinger: 'ekstraboksEgenInntektIngressLaerlinger' as keyof VeilederIofDto,
            lenkeLaerlinger: 'ekstraboksEgenInntektLenkeLaerlinger' as keyof VeilederIofDto,
            tittelVideregaende: 'ekstraboksEgenInntektTittelVideregaende' as keyof VeilederIofDto,
            ingressVideregaende: 'ekstraboksEgenInntektIngressVideregaende' as keyof VeilederIofDto,
        };
    } else if (valg === ResultatType.ResE) {
        return {
            tittelLaerlinger: 'ekstraboksTrygdTittelLaerlinger' as keyof VeilederIofDto,
            ingressLaerlinger: 'ekstraboksTrygdIngressLaerlinger' as keyof VeilederIofDto,
            lenkeLaerlinger: 'ekstraboksTrygdLenkeLaerlinger' as keyof VeilederIofDto,
            tittelVideregaende: 'ekstraboksTrygdTittelVideregaende' as keyof VeilederIofDto,
            ingressVideregaende: 'ekstraboksTrygdIngressVideregaende' as keyof VeilederIofDto,
            lenkeVideregaende: 'ekstraboksTrygdLenkeVideregaende' as keyof VeilederIofDto,
        };
    }

    return undefined;
};

export const getModal = (state: ValgState): Modal | undefined => {
    const valg = findResultat(state);
    if (valg === ResultatType.ResA) {
        return {
            tittel: 'modalLanStipendTittel' as keyof VeilederIofDto,
            content: 'modalLanStipendContent' as keyof VeilederIofDto,
            ariaLabel: 'modalLanStipendAriaLabel' as keyof VeilederIofDto,
        };
    } else if (valg === ResultatType.ResD) {
        return {
            tittel: 'modalFormueTittel' as keyof VeilederIofDto,
            content: 'modalFormueContent' as keyof VeilederIofDto,
            ariaLabel: 'modalFormueAriaLabel' as keyof VeilederIofDto,
        };
    } else if (valg === ResultatType.ResE) {
        return {
            tittel: 'modalTrygdPensjonTittel' as keyof VeilederIofDto,
            content: 'modalTrygdPensjonContent' as keyof VeilederIofDto,
            ariaLabel: 'modalTrygdPensjonAriaLabel' as keyof VeilederIofDto,
        };
    }

    return undefined;
};

const findResultat = (state: ValgState): ResultatType => {
    if (state.aInntekt !== undefined) {
        if (state.aInntekt.value === AInntektValg.a1_egenInntekt) {
            return ResultatType.ResA;
        }
        if (state.aInntekt.value === AInntektValg.a2_ektefelleSamboer) {
            return ResultatType.ResB;
        }
        if (state.aInntekt.value === AInntektValg.a3_foreldre) {
            return ResultatType.ResC;
        }
        if (state.aInntekt.value === AInntektValg.a4_formue) {
            return ResultatType.ResD;
        }
        if (state.aInntekt.value === AInntektValg.a5_trygd) {
            return ResultatType.ResE;
        }
    }

    return ResultatType.Uknown;
};
